import { Component, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-pricing-hero',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './pricing-hero.html',
  styleUrls: ['./pricing-hero.css'],
})
export class PricingHeroComponent {
  @Output() yearlyChange = new EventEmitter<boolean>();
  isYearly = false;

  setYearly(val: boolean): void {
    this.isYearly = val;
    this.yearlyChange.emit(val);
  }
}
